import useOneRepMaxChartDataApi from "../useOneRepMaxChartDataApi";
import OneRepMaxChartDataContext from "../contexts/OneRepMaxChartDataContext";
import OneRepMaxChartStatusContext from "../contexts/OneRepMaxChartStatusContext";
import OneRepMaxChartLinesProvider from "../providers/OneRepMaxChartLinesProvider";

interface OneRepMaxChartDataProviderProps {
  children?: React.ReactNode;
}

function OneRepMaxChartDataProvider(props: OneRepMaxChartDataProviderProps) {
  const { data, status } = useOneRepMaxChartDataApi();

  return (
    <OneRepMaxChartDataContext.Provider value={data}>
      <OneRepMaxChartStatusContext.Provider value={status}>
        <OneRepMaxChartLinesProvider>{props.children}</OneRepMaxChartLinesProvider>
      </OneRepMaxChartStatusContext.Provider>
    </OneRepMaxChartDataContext.Provider>
  );
}

export default OneRepMaxChartDataProvider;
